import React from 'react';

export function GallerySkeleton() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="h-40 bg-slate-200 border-2 border-black rounded-xl animate-pulse" />
      ))}
    </div>
  );
}

export function DetailSkeleton() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-8 grid md:grid-cols-3 gap-6">
      <div className="md:col-span-2 space-y-4">
        <div className="h-24 bg-slate-200 border-2 border-black rounded-xl animate-pulse" />
        <div className="h-48 bg-slate-200 border-2 border-black rounded-xl animate-pulse" />
        <div className="h-48 bg-slate-200 border-2 border-black rounded-xl animate-pulse" />
      </div>
      <div className="space-y-4">
        <div className="h-40 bg-slate-200 border-2 border-black rounded-xl animate-pulse" />
        <div className="h-40 bg-slate-200 border-2 border-black rounded-xl animate-pulse" />
      </div>
    </div>
  );
}


